import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'formValue',
  pure: false
})
export class FormValuePipe implements PipeTransform, OnDestroy {
  private _subscription: Subscription;
  private _control: AbstractControl;
  private _lastValue: any;

  constructor(private _changeDetector: ChangeDetectorRef) {}

  ngOnDestroy() {
    this._dispose();
  }

  transform(obj: any, args?: any): any {
    if(this._control !== obj ){
      this._dispose();
      this._control = obj;
      if(this._control && this._control.valueChanges) {
        this._subscription = this._control.valueChanges.subscribe(() => {
          if(this._lastValue !== this._control ? this._control.value : null){
            this._changeDetector.markForCheck();
          }
        });
      }
    }
    this._lastValue = this._control ? this._control.value : null;
    return this._lastValue;
  }

  private _dispose() {
    if(this._subscription) {
      this._subscription.unsubscribe();
    }
    this._subscription = null;
    this._control = null;
    this._lastValue = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/pipes/form-value.pipe.ts